import React from "react";

/**
 * Sophisticated 4-point sparkle (concave star) with a small secondary glint.
 * Uses currentColor so it inherits the surrounding text color.
 */
const Sparkle = ({ className, size = 24, ...props }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 1.5c.4 4.9 2.7 7.2 7.6 7.6-4.9.4-7.2 2.7-7.6 7.6-.4-4.9-2.7-7.2-7.6-7.6C9.3 8.7 11.6 6.4 12 1.5Z" />
    <path
      d="M18.6 14.2c.18 2.1 1.1 3.02 3.2 3.2-2.1.18-3.02 1.1-3.2 3.2-.18-2.1-1.1-3.02-3.2-3.2 2.1-.18 3.02-1.1 3.2-3.2Z"
      opacity="0.65"
    />
  </svg>
);

export default Sparkle;
